import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import ContactPage from '@/views/ContactPage.vue'
import AboutPage from '@/views/AboutPage.vue';

const routes = [
  {path: '/', name: 'Home',component: HomePage},
  { path: '/contact', name: 'ContactPage', component: ContactPage },
  { path: '/about', name: 'AboutPage',component: AboutPage}
];

const currentPath = window.location.pathname
const base = '/' + currentPath.split('/')[1]

const router = createRouter({
  history: createWebHistory(base),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; 
    } else {
      return { top: 0, behavior: 'smooth' }; 
    }
  }
});

export default router;
